import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mealName: "",
  guestInfo: {
    guestName: "",
    guestBillingTypeId: null, //References Facility_GuestCharge table now, used to be hard-coded
    selectedResident: null, //residentID to tie order to for "Guest" type
    selectedGuestType: null, // 1, 2, 3 for Guest/Employee/Other respectively
    employeeId: null,
    residentMealPlanCharge: false //true if selected guest charge should apply to resident's meal plan
  },
  menuInfo: null,
  lastMealSelected: {
    setupId: null,
    mealName: null
  },
  orderWorkflow: null,
  lastTableFilter: {
    tableId: null,
    tableName: null
  },
  lastWingFilter: null,
  heldViewLastTableFilter: {
    tableId: null,
    talbeName: null
  },
  heldViewLastWingFilter: null,
  showOnlyUserOrders: true,
  lastHeldMealSelected: {
    setupId: null,
    mealName: null
  },
  heldOrderSortModel: null,
  submittedOrderSortModel: null,
  submittedLastTableFilter: {
    tableId: null,
    tableName: null
  },
  submittedLastWingFilter: null,
  submittedLastMealSelected: {
    setupId: null,
    mealName: null
  },
  lastMgmtMealSelected: {
    setupId: null,
    mealName: null
  }
}

export const OrderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    //just for title bar
    setSelectedMeal: (state, action) => {
      state.mealName = action.payload;
    },
    setGuestInfo: (state, action) => {
      state.guestInfo = {...action.payload};
    },
    //for storage and retrieval on held/submitted order edits
    setMenuInfo: (state, action) => {
      state.menuInfo = {...action.payload};
    },
    setLastMealSelected: (state, action) => {
      state.lastMealSelected = {...action.payload};
    },
    setOrderWorkflow: (state, action) => {
      state.orderWorkflow = action.payload;
    },
    setLastTableFilter: (state, action) => {
      state.lastTableFilter = {...action.payload};
    },
    setLastWingFilter: (state, action) => {
      state.lastWingFilter = action.payload;
    },
    setHeldViewLastTableFilter: (state, action) => {
      state.heldViewLastTableFilter = {...action.payload};
    },
    setHeldViewLastWingFilter: (state, action) => {
      state.heldViewLastWingFilter = action.payload;
    },
    setShowOnlyUserOrders: (state, action) => {
      state.showOnlyUserOrders = action.payload;
    },
    setLastHeldMealSelected: (state, action) => {
      state.lastHeldMealSelected = action.payload;
    },
    setHeldOrderSortModel: (state, action) => {
      state.heldOrderSortModel = [...action.payload];
    },
    setSubmittedOrderSortModel: (state, action) => {
      state.submittedOrderSortModel = [...action.payload];
    },
    setSubmittedLastTableFilter: (state, action) => {
      state.submittedLastTableFilter = {...action.payload};
    },
    setSubmittedLastWingFilter: (state, action) => {
      state.submittedLastWingFilter = action.payload;
    },
    setSubmittedLastMealSelected: (state, action) => {
      state.submittedLastMealSelected = {...action.payload};
    },
    setLastMgmtMealSelected: (state, action) => {
      state.lastMgmtMealSelected = {...action.payload};
    }
  }
})

export const { 
  setSelectedMeal, 
  setGuestInfo, 
  setMenuInfo,
  setLastMealSelected,
  setOrderWorkflow,
  setLastTableFilter,
  setLastWingFilter,
  setHeldViewLastTableFilter,
  setHeldViewLastWingFilter,
  setShowOnlyUserOrders,
  setLastHeldMealSelected,
  setHeldOrderSortModel,
  setSubmittedOrderSortModel,
  setSubmittedLastTableFilter,
  setSubmittedLastWingFilter,
  setSubmittedLastMealSelected,
  setLastMgmtMealSelected
} = OrderSlice.actions;
export const selectActiveMeals = (state) => state?.order?.activeMeals;
export const selectResidentInfo = (state) => state?.order?.residentInfo;
export const selectMealName = (state) => state?.order?.mealName;
export const selectMenuInfo = (state) => state?.order?.menuInfo;
export const selectGuestInfo = (state) => state?.order?.guestInfo;
export const selectLastMealSelected = (state) => state?.order?.lastMealSelected;
export const selectOrderWorkflow = (state) => state?.order?.orderWorkflow;
export const selectLastTableFilter = (state) => state?.order?.lastTableFilter;
export const selectLastWingFilter = (state) => state?.order?.lastWingFilter;
export const selectHeldViewLastTableFilter = (state) => state?.order?.heldViewLastTableFilter;
export const selectHeldViewLastWingFilter = (state) => state?.order?.heldViewLastWingFilter;
export const selectShowOnlyUserOrders = (state) => state?.order?.showOnlyUserOrders;
export const selectLastHeldMealSelected = (state) => state?.order?.lastHeldMealSelected;
export const selectHeldOrderSortModel = (state) => state?.order?.heldOrderSortModel;
export const selectSubmittedOrderSortModel = (state) => state?.order?.submittedOrderSortModel;
export const selectSubmittedLastTableFilter = (state) => state?.order?.submittedLastTableFilter;
export const selectSubmittedLastWingFilter = (state) => state?.order?.submittedLastWingFilter;
export const selectSubmittedLastMealSelected = (state) => state?.order?.submittedLastMealSelected;
export const selectLastMgmtMealSelected = (state) => state?.order?.lastMgmtMealSelected;

export default OrderSlice.reducer;